import React from 'react';
import CompletePurchaseShell from '../complete-purchase-shell';
import type { CompletePurchasePayAtOrderRenderProps } from '../complete-purchase-shell';
import type { CompletePurchaseStepProps } from '../complete-purchase.types';
import { PayAtOrder } from '../components/pay-at-order';

const renderPayAtOrder = ({
  onSubmit,
  editPaymentMethod
}: CompletePurchasePayAtOrderRenderProps) => (
  <PayAtOrder onSubmit={onSubmit} editPaymentMethod={editPaymentMethod} />
);

const CompletePurchaseControl: React.FC<CompletePurchaseStepProps> = props => {
  return <CompletePurchaseShell {...props} renderPayAtOrder={renderPayAtOrder} />;
};

export default CompletePurchaseControl;
